import { useStore } from '@stores';
import { useEffect } from 'react';

export const useInvoice = (id: string | undefined) => {
  const { invoiceStore } = useStore();
  const { invoice, loading } = invoiceStore;

  useEffect(() => {
    id && invoiceStore.get({ id });
  }, [invoiceStore, id]);

  return { invoice, loading };
};
